<script lang="ts"></script>

<style lang="scss">
  :host {
    width: fit-content;
  }
</style>
